import { render } from "./PlaceListItem.vue?vue&type=template&id=20f0d17c&scoped=true"
import script from "./PlaceListItem.vue?vue&type=script&lang=js"
export * from "./PlaceListItem.vue?vue&type=script&lang=js"

import "./PlaceListItem.vue?vue&type=style&index=0&id=20f0d17c&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f0d17c"]])

export default __exports__